import { ChipProps } from '@mui/material';

import { EVENT_RETRY_STATUS } from '../../../services/Hub/notificationCenter/types';

export function getStatusColor(status: EVENT_RETRY_STATUS): ChipProps['color'] {
  if (EVENT_RETRY_STATUS.FAILED === status) return 'error';
  if (EVENT_RETRY_STATUS.SUCCEEDED === status) return 'success';
  if (EVENT_RETRY_STATUS.DISMISSED === status) return 'default';
  if (EVENT_RETRY_STATUS.PENDING === status) return 'info';
  return 'warning';
}
